import { render, staticRenderFns } from "./UpdateZclousureCollection.vue?vue&type=template&id=7c97fbfe&"
import script from "./UpdateZclousureCollection.vue?vue&type=script&lang=js&"
export * from "./UpdateZclousureCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports